// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'Source Sans Pro';
  src: url('/static/fonts/SourceSansPro-Regular.ttf') format('truetype');
  font-weight: 400;
  font-style: normal;
  font-display: block;
}

@font-face {
  font-family: 'Source Sans Pro';
  src: url('/static/fonts/SourceSansPro-Bold.ttf') format('truetype');
  font-weight: 700;
  font-style: normal;
  font-display: block;
}

@font-face {
  font-family: 'Source Sans Pro';
  src: url('/static/fonts/SourceSansPro-Light.ttf') format('truetype');
  font-weight: 300;
  font-style: normal;
  font-display: block;
}

.fase-monitor {
  min-height: 100vh;
  background: #f1f5f9;
  color: #0f172a;
  font-family:
    'Source Sans Pro',
    -apple-system,
    BlinkMacSystemFont,
    'Segoe UI',
    Helvetica,
    Arial,
    sans-serif;
}

.fase-monitor__header {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  gap: 1rem;
  min-height: 48px;
  padding: 1rem 1.25rem;
  background: #ffffff;
  border-bottom: 1px solid #e2e8f0;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}

.fase-monitor__header-start {
  justify-self: start;
  min-width: 0;
}

.fase-monitor__header-end {
  justify-self: end;
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.fase-monitor__logout {
  flex: none;
  box-sizing: border-box;
  min-height: 2.375rem;
  padding: 0.5rem 0.75rem;
  font-size: 0.875rem;
  font-weight: 600;
  line-height: 1.25;
  color: #ffffff;
  background: #ff5300;
  border: 1px solid #ff5300;
  border-radius: 8px;
  cursor: pointer;
  transition:
    border-color 0.15s ease,
    background-color 0.15s ease;
}

.fase-monitor__logout:hover {
  background: #e04a00;
  border-color: #e04a00;
}

.fase-monitor__header-center {
  justify-self: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  min-width: 0;
  text-align: center;
}

.fase-monitor__header-title-row {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin: 0;
  font-size: 1.125rem;
  font-weight: 700;
  letter-spacing: -0.02em;
  line-height: 1.2;
}

.fase-monitor__header-title-row > span {
  color: #0f172a;
}

.fase-monitor__header-subtitle {
  margin: 0;
  font-size: 0.8125rem;
  font-weight: 500;
  color: #334155;
  line-height: 1.3;
}

.fase-monitor__branding {
  width: 160px;
  height: 48px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  overflow: hidden;
}

.fase-monitor__branding img {
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
  object-fit: contain;
}

.fase-monitor__branding-name {
  font-size: 1rem;
  font-weight: 700;
  line-height: 1.2;
  color: #0f172a;
}

.fase-monitor__select-wrap {
  width: 220px;
  flex-shrink: 0;
}

.fase-monitor__select {
  box-sizing: border-box;
  width: 100%;
  min-height: 2.375rem;
  font-size: 0.875rem;
  line-height: 1.25;
  padding: 0.5rem 2rem 0.5rem 0.75rem;
  border-radius: 8px;
  border: 1px solid #cbd5e1;
  background: #ffffff
    url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%2364748b' d='M2 4l4 4 4-4'/%3E%3C/svg%3E")
    no-repeat right 0.75rem center;
  appearance: none;
  color: #0f172a;
  cursor: pointer;
  transition:
    border-color 0.15s ease,
    box-shadow 0.15s ease;
}

.fase-monitor__select:hover {
  border-color: #94a3b8;
}

.fase-monitor__select:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15);
}

.fase-monitor__box-page {
  max-width: 920px;
  margin: 0 auto;
  padding: 1.5rem 1rem 2rem;
  box-sizing: border-box;
}

.fase-monitor__box-hero {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 1rem 1.25rem;
  margin-bottom: 1.5rem;
  padding: 0.25rem 0;
  text-align: center;
}

.fase-monitor__box-title {
  font-size: 1.5rem;
  font-weight: 700;
  letter-spacing: -0.02em;
  color: #0f172a;
}

.fase-monitor__box-image {
  width: 72px;
  height: auto;
}

.fase-monitor__box-details {
  max-width: 720px;
  margin: 1rem auto 0;
  padding: 2.5rem 3rem;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 2rem 3.5rem;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.05);
  text-align: left;
  box-sizing: border-box;
}

.fase-monitor__box-field-label {
  font-size: 0.8125rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  color: #334155;
}

.fase-monitor__box-field-value {
  margin-top: 0.75rem;
  font-size: 1rem;
  color: #0f172a;
}

.fase-monitor__box-field-value > div {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
}

.fase-monitor__page {
  max-width: 920px;
  margin: 0 auto;
  padding: 1.5rem 1rem 2rem;
  box-sizing: border-box;
}

.fase-monitor__status {
  text-align: center;
  padding: 3rem 1rem;
  font-size: 1rem;
  color: #64748b;
}

.fase-monitor__status--error {
  color: #dc2626;
  font-weight: 600;
}

.fase-monitor__stats {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 1rem;
  margin-bottom: 1.5rem;
}

.fase-monitor__card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.05);
}

.fase-monitor__health-card {
  padding: 1rem 1.125rem 0.75rem;
}

.fase-monitor__health-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.75rem;
}

.fase-monitor__health-title {
  font-size: 0.9375rem;
  font-weight: 700;
  color: #0f172a;
}

.fase-monitor__health-chart {
  width: 22px;
  height: 22px;
  flex-shrink: 0;
}

.fase-monitor__health-chart--empty {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  border: 2px solid #e2e8f0;
  box-sizing: border-box;
}

.fase-monitor__health-row {
  display: flex;
  align-items: center;
  padding: 0.4rem 0.5rem;
  margin: 0 -0.5rem;
  border-radius: 8px;
  border: 1px solid transparent;
  cursor: pointer;
  transition:
    background-color 0.15s ease,
    border-color 0.15s ease;
}

.fase-monitor__health-row:hover {
  background: #f8fafc;
}

.fase-monitor__health-row--active {
  background: #eff6ff;
  border-color: #bfdbfe;
}

.fase-monitor__health-label {
  flex: 1;
  min-width: 0;
}

.fase-monitor__health-value {
  width: 3rem;
  text-align: right;
  font-size: 0.875rem;
  color: #475569;
}

.fase-monitor__health-count {
  width: 2rem;
  text-align: right;
  font-size: 0.875rem;
  font-weight: 600;
  color: #0f172a;
}

.fase-monitor__sections {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.fase-monitor__section {
  overflow: hidden;
}

.fase-monitor__section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  width: 100%;
  padding: 0.875rem 1rem;
  border: none;
  background: #ffffff;
  cursor: pointer;
  text-align: left;
  transition: background-color 0.15s ease;
}

.fase-monitor__section-header:hover {
  background: #f8fafc;
}

.fase-monitor__section-header-left {
  display: flex;
  align-items: center;
  gap: 0.625rem;
  min-width: 0;
}

.fase-monitor__section-title {
  font-size: 0.8125rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  color: #334155;
}

.fase-monitor__section-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 1.5rem;
  height: 1.5rem;
  padding: 0 0.5rem;
  border-radius: 999px;
  background: #e2e8f0;
  font-size: 0.75rem;
  font-weight: 700;
  color: #475569;
}

.fase-monitor__chevron {
  width: 0.5rem;
  height: 0.5rem;
  border-right: 2px solid #64748b;
  border-bottom: 2px solid #64748b;
  transform: rotate(45deg);
  transition: transform 0.2s ease;
  flex-shrink: 0;
}

.fase-monitor__chevron--collapsed {
  transform: rotate(-45deg);
  margin-top: -0.15rem;
}

.fase-monitor__section-body {
  border-top: 1px solid #f1f5f9;
  background: #ffffff;
}

.fase-monitor__empty {
  padding: 1.25rem 1rem;
  font-size: 0.875rem;
  color: #64748b;
}

.fase-monitor__aircraft-list > .fase-monitor__aircraft-row:not(:last-child) {
  border-bottom: 1px solid #f1f5f9;
}

.fase-monitor__aircraft-row {
  display: grid;
  grid-template-columns: minmax(110px, 130px) minmax(0, 1fr);
  gap: 1rem;
  padding: 1rem;
}

.fase-monitor__aircraft-identity {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.5rem;
}

.fase-monitor__aircraft-identity img {
  width: 56px;
  height: auto;
}

.fase-monitor__aircraft-details {
  display: grid;
  gap: 1rem;
}

.fase-monitor__aircraft-meta table {
  width: 100%;
  border-collapse: collapse;
}

.fase-monitor__aircraft-meta td {
  padding: 0.2rem 0;
  font-size: 0.875rem;
  vertical-align: top;
}

.fase-monitor__aircraft-meta td:first-child {
  width: 7rem;
  color: #64748b;
  font-weight: 600;
}

.fase-monitor__aircraft-boxes-label {
  display: block;
  margin-bottom: 0.5rem;
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #64748b;
}

.fase-monitor__box-line {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem 0.75rem;
  margin-bottom: 0.5rem;
}

.fase-monitor__box-line:last-child {
  margin-bottom: 0;
}

.fase-monitor__box-updated {
  font-size: 0.75rem;
  color: #64748b;
}

.fase-monitor__spare {
  padding: 0.5rem 0 0.75rem;
}

.fase-monitor__spare-head,
.fase-monitor__spare-row {
  display: grid;
  grid-template-columns: minmax(0, 1.2fr) minmax(0, 1fr) minmax(5rem, auto);
  gap: 0.75rem;
  align-items: center;
  padding: 0.75rem 1rem;
}

.fase-monitor__spare-head {
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #64748b;
  border-bottom: 1px solid #e2e8f0;
}

.fase-monitor__spare-row {
  font-size: 0.875rem;
  border-bottom: 1px solid #f1f5f9;
  transition: background-color 0.15s ease;
}

.fase-monitor__spare-row:hover {
  background: #f8fafc;
}

.fase-monitor__spare-location {
  padding: 0.875rem 1rem 0.35rem;
  font-size: 0.8125rem;
  font-weight: 700;
  color: #475569;
}

.fase-monitor__spare-box {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  min-width: 0;
}

.fase-monitor__spare-sync {
  color: #334155;
}

.fase-monitor__spare-head > :last-child,
.fase-monitor__spare-seen {
  text-align: right;
}

.fase-monitor__spare-seen {
  color: #64748b;
  font-size: 0.8125rem;
}

.fase-monitor--auth {
  display: flex;
  align-items: center;
  justify-content: center;
}

.fase-monitor__auth-overlay {
  width: 100%;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
  box-sizing: border-box;
}

.fase-monitor__auth-card {
  width: 100%;
  max-width: 380px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  box-shadow: 0 4px 16px rgba(15, 23, 42, 0.08);
  padding: 2rem 2rem 2.25rem;
  box-sizing: border-box;
}

.fase-monitor__auth-logo-wrapper {
  display: flex;
  justify-content: center;
  margin-bottom: 1.25rem;
}

.fase-monitor__auth-logo {
  height: 38px;
  width: auto;
  object-fit: contain;
}

.fase-monitor__auth-title {
  margin: 0 0 0.375rem;
  font-size: 1.25rem;
  font-weight: 700;
  letter-spacing: -0.02em;
  color: #0f172a;
  text-align: center;
}

.fase-monitor__auth-subtitle {
  margin: 0 0 1.75rem;
  font-size: 0.875rem;
  color: #64748b;
  text-align: center;
}

.fase-monitor__auth-form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.fase-monitor__auth-field {
  display: flex;
  flex-direction: column;
  gap: 0.375rem;
}

.fase-monitor__auth-label {
  font-size: 0.8125rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  color: #334155;
}

.fase-monitor__auth-input {
  width: 100%;
  padding: 0.5rem 0.75rem;
  font-size: 0.9375rem;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  color: #0f172a;
  background: #ffffff;
  box-sizing: border-box;
  transition:
    border-color 0.15s ease,
    box-shadow 0.15s ease;
}

.fase-monitor__auth-input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15);
}

.fase-monitor__auth-input:disabled {
  background: #f8fafc;
  color: #94a3b8;
}

.fase-monitor__auth-error {
  margin: 0;
  padding: 0.625rem 0.75rem;
  font-size: 0.875rem;
  color: #dc2626;
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 8px;
}

.fase-monitor__auth-submit {
  margin-top: 0.5rem;
  padding: 0.625rem 1rem;
  font-size: 0.9375rem;
  font-weight: 600;
  color: #ffffff;
  background: #ff5300;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.15s ease;
}

.fase-monitor__auth-submit:hover:not(:disabled) {
  background: #e04a00;
}

.fase-monitor__auth-submit:disabled {
  background: #ffb899;
  cursor: not-allowed;
}

@media (min-width: 720px) {
  .fase-monitor__aircraft-row {
    grid-template-columns: 130px minmax(0, 1fr);
  }

  .fase-monitor__aircraft-details {
    grid-template-columns: minmax(0, 1fr) minmax(220px, 260px);
  }
}

@media (max-width: 719px) {
  .fase-monitor__aircraft-details {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./css/fase-monitor.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,sEAAsE;EACtE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,mEAAmE;EACnE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,oEAAoE;EACpE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd;;;;;;;cAOY;AACd;;AAEA;EACE,aAAa;EACb,mCAAmC;EACnC,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,gCAAgC;EAChC,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,UAAU;EACV,sBAAsB;EACtB,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf;;+BAE6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,WAAW;EACX,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,mCAAmC;EACnC,kBAAkB;EAClB,yBAAyB;EACzB;;kCAEgC;EAChC,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf;;yBAEuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,aAAa;EACb,gDAAgD;EAChD,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,4CAA4C;EAC5C,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;EACf;;2BAEyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,+BAA+B;EAC/B,gCAAgC;EAChC,wBAAwB;EACxB,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,0DAA0D;EAC1D,SAAS;EACT,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,aAAa;EACb,yEAAyE;EACzE,YAAY;EACZ,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,6CAA6C;EAC7C,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,oBAAoB;EACpB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,sBAAsB;EACtB;;yBAEuB;AACzB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE;IACE,2CAA2C;EAC7C;;EAEA;IACE,0DAA0D;EAC5D;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["@font-face {\n  font-family: 'Source Sans Pro';\n  src: url('/static/fonts/SourceSansPro-Regular.ttf') format('truetype');\n  font-weight: 400;\n  font-style: normal;\n  font-display: block;\n}\n\n@font-face {\n  font-family: 'Source Sans Pro';\n  src: url('/static/fonts/SourceSansPro-Bold.ttf') format('truetype');\n  font-weight: 700;\n  font-style: normal;\n  font-display: block;\n}\n\n@font-face {\n  font-family: 'Source Sans Pro';\n  src: url('/static/fonts/SourceSansPro-Light.ttf') format('truetype');\n  font-weight: 300;\n  font-style: normal;\n  font-display: block;\n}\n\n.fase-monitor {\n  min-height: 100vh;\n  background: #f1f5f9;\n  color: #0f172a;\n  font-family:\n    'Source Sans Pro',\n    -apple-system,\n    BlinkMacSystemFont,\n    'Segoe UI',\n    Helvetica,\n    Arial,\n    sans-serif;\n}\n\n.fase-monitor__header {\n  display: grid;\n  grid-template-columns: 1fr auto 1fr;\n  align-items: center;\n  gap: 1rem;\n  min-height: 48px;\n  padding: 1rem 1.25rem;\n  background: #ffffff;\n  border-bottom: 1px solid #e2e8f0;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n}\n\n.fase-monitor__header-start {\n  justify-self: start;\n  min-width: 0;\n}\n\n.fase-monitor__header-end {\n  justify-self: end;\n  min-width: 0;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.fase-monitor__logout {\n  flex: none;\n  box-sizing: border-box;\n  min-height: 2.375rem;\n  padding: 0.5rem 0.75rem;\n  font-size: 0.875rem;\n  font-weight: 600;\n  line-height: 1.25;\n  color: #ffffff;\n  background: #ff5300;\n  border: 1px solid #ff5300;\n  border-radius: 8px;\n  cursor: pointer;\n  transition:\n    border-color 0.15s ease,\n    background-color 0.15s ease;\n}\n\n.fase-monitor__logout:hover {\n  background: #e04a00;\n  border-color: #e04a00;\n}\n\n.fase-monitor__header-center {\n  justify-self: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.5rem;\n  min-width: 0;\n  text-align: center;\n}\n\n.fase-monitor__header-title-row {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  margin: 0;\n  font-size: 1.125rem;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  line-height: 1.2;\n}\n\n.fase-monitor__header-title-row > span {\n  color: #0f172a;\n}\n\n.fase-monitor__header-subtitle {\n  margin: 0;\n  font-size: 0.8125rem;\n  font-weight: 500;\n  color: #334155;\n  line-height: 1.3;\n}\n\n.fase-monitor__branding {\n  width: 160px;\n  height: 48px;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  overflow: hidden;\n}\n\n.fase-monitor__branding img {\n  max-width: 100%;\n  max-height: 100%;\n  width: auto;\n  height: auto;\n  object-fit: contain;\n}\n\n.fase-monitor__branding-name {\n  font-size: 1rem;\n  font-weight: 700;\n  line-height: 1.2;\n  color: #0f172a;\n}\n\n.fase-monitor__select-wrap {\n  width: 220px;\n  flex-shrink: 0;\n}\n\n.fase-monitor__select {\n  box-sizing: border-box;\n  width: 100%;\n  min-height: 2.375rem;\n  font-size: 0.875rem;\n  line-height: 1.25;\n  padding: 0.5rem 2rem 0.5rem 0.75rem;\n  border-radius: 8px;\n  border: 1px solid #cbd5e1;\n  background: #ffffff\n    url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%2364748b' d='M2 4l4 4 4-4'/%3E%3C/svg%3E\")\n    no-repeat right 0.75rem center;\n  appearance: none;\n  color: #0f172a;\n  cursor: pointer;\n  transition:\n    border-color 0.15s ease,\n    box-shadow 0.15s ease;\n}\n\n.fase-monitor__select:hover {\n  border-color: #94a3b8;\n}\n\n.fase-monitor__select:focus {\n  outline: none;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15);\n}\n\n.fase-monitor__box-page {\n  max-width: 920px;\n  margin: 0 auto;\n  padding: 1.5rem 1rem 2rem;\n  box-sizing: border-box;\n}\n\n.fase-monitor__box-hero {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-wrap: wrap;\n  gap: 1rem 1.25rem;\n  margin-bottom: 1.5rem;\n  padding: 0.25rem 0;\n  text-align: center;\n}\n\n.fase-monitor__box-title {\n  font-size: 1.5rem;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  color: #0f172a;\n}\n\n.fase-monitor__box-image {\n  width: 72px;\n  height: auto;\n}\n\n.fase-monitor__box-details {\n  max-width: 720px;\n  margin: 1rem auto 0;\n  padding: 2.5rem 3rem;\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 2rem 3.5rem;\n  background: #ffffff;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.05);\n  text-align: left;\n  box-sizing: border-box;\n}\n\n.fase-monitor__box-field-label {\n  font-size: 0.8125rem;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  color: #334155;\n}\n\n.fase-monitor__box-field-value {\n  margin-top: 0.75rem;\n  font-size: 1rem;\n  color: #0f172a;\n}\n\n.fase-monitor__box-field-value > div {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n}\n\n.fase-monitor__page {\n  max-width: 920px;\n  margin: 0 auto;\n  padding: 1.5rem 1rem 2rem;\n  box-sizing: border-box;\n}\n\n.fase-monitor__status {\n  text-align: center;\n  padding: 3rem 1rem;\n  font-size: 1rem;\n  color: #64748b;\n}\n\n.fase-monitor__status--error {\n  color: #dc2626;\n  font-weight: 600;\n}\n\n.fase-monitor__stats {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 1rem;\n  margin-bottom: 1.5rem;\n}\n\n.fase-monitor__card {\n  background: #ffffff;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.05);\n}\n\n.fase-monitor__health-card {\n  padding: 1rem 1.125rem 0.75rem;\n}\n\n.fase-monitor__health-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 0.75rem;\n}\n\n.fase-monitor__health-title {\n  font-size: 0.9375rem;\n  font-weight: 700;\n  color: #0f172a;\n}\n\n.fase-monitor__health-chart {\n  width: 22px;\n  height: 22px;\n  flex-shrink: 0;\n}\n\n.fase-monitor__health-chart--empty {\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n  border: 2px solid #e2e8f0;\n  box-sizing: border-box;\n}\n\n.fase-monitor__health-row {\n  display: flex;\n  align-items: center;\n  padding: 0.4rem 0.5rem;\n  margin: 0 -0.5rem;\n  border-radius: 8px;\n  border: 1px solid transparent;\n  cursor: pointer;\n  transition:\n    background-color 0.15s ease,\n    border-color 0.15s ease;\n}\n\n.fase-monitor__health-row:hover {\n  background: #f8fafc;\n}\n\n.fase-monitor__health-row--active {\n  background: #eff6ff;\n  border-color: #bfdbfe;\n}\n\n.fase-monitor__health-label {\n  flex: 1;\n  min-width: 0;\n}\n\n.fase-monitor__health-value {\n  width: 3rem;\n  text-align: right;\n  font-size: 0.875rem;\n  color: #475569;\n}\n\n.fase-monitor__health-count {\n  width: 2rem;\n  text-align: right;\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: #0f172a;\n}\n\n.fase-monitor__sections {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.fase-monitor__section {\n  overflow: hidden;\n}\n\n.fase-monitor__section-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  width: 100%;\n  padding: 0.875rem 1rem;\n  border: none;\n  background: #ffffff;\n  cursor: pointer;\n  text-align: left;\n  transition: background-color 0.15s ease;\n}\n\n.fase-monitor__section-header:hover {\n  background: #f8fafc;\n}\n\n.fase-monitor__section-header-left {\n  display: flex;\n  align-items: center;\n  gap: 0.625rem;\n  min-width: 0;\n}\n\n.fase-monitor__section-title {\n  font-size: 0.8125rem;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  color: #334155;\n}\n\n.fase-monitor__section-badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 1.5rem;\n  height: 1.5rem;\n  padding: 0 0.5rem;\n  border-radius: 999px;\n  background: #e2e8f0;\n  font-size: 0.75rem;\n  font-weight: 700;\n  color: #475569;\n}\n\n.fase-monitor__chevron {\n  width: 0.5rem;\n  height: 0.5rem;\n  border-right: 2px solid #64748b;\n  border-bottom: 2px solid #64748b;\n  transform: rotate(45deg);\n  transition: transform 0.2s ease;\n  flex-shrink: 0;\n}\n\n.fase-monitor__chevron--collapsed {\n  transform: rotate(-45deg);\n  margin-top: -0.15rem;\n}\n\n.fase-monitor__section-body {\n  border-top: 1px solid #f1f5f9;\n  background: #ffffff;\n}\n\n.fase-monitor__empty {\n  padding: 1.25rem 1rem;\n  font-size: 0.875rem;\n  color: #64748b;\n}\n\n.fase-monitor__aircraft-list > .fase-monitor__aircraft-row:not(:last-child) {\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.fase-monitor__aircraft-row {\n  display: grid;\n  grid-template-columns: minmax(110px, 130px) minmax(0, 1fr);\n  gap: 1rem;\n  padding: 1rem;\n}\n\n.fase-monitor__aircraft-identity {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 0.5rem;\n}\n\n.fase-monitor__aircraft-identity img {\n  width: 56px;\n  height: auto;\n}\n\n.fase-monitor__aircraft-details {\n  display: grid;\n  gap: 1rem;\n}\n\n.fase-monitor__aircraft-meta table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.fase-monitor__aircraft-meta td {\n  padding: 0.2rem 0;\n  font-size: 0.875rem;\n  vertical-align: top;\n}\n\n.fase-monitor__aircraft-meta td:first-child {\n  width: 7rem;\n  color: #64748b;\n  font-weight: 600;\n}\n\n.fase-monitor__aircraft-boxes-label {\n  display: block;\n  margin-bottom: 0.5rem;\n  font-size: 0.75rem;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: #64748b;\n}\n\n.fase-monitor__box-line {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.5rem 0.75rem;\n  margin-bottom: 0.5rem;\n}\n\n.fase-monitor__box-line:last-child {\n  margin-bottom: 0;\n}\n\n.fase-monitor__box-updated {\n  font-size: 0.75rem;\n  color: #64748b;\n}\n\n.fase-monitor__spare {\n  padding: 0.5rem 0 0.75rem;\n}\n\n.fase-monitor__spare-head,\n.fase-monitor__spare-row {\n  display: grid;\n  grid-template-columns: minmax(0, 1.2fr) minmax(0, 1fr) minmax(5rem, auto);\n  gap: 0.75rem;\n  align-items: center;\n  padding: 0.75rem 1rem;\n}\n\n.fase-monitor__spare-head {\n  font-size: 0.75rem;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: #64748b;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.fase-monitor__spare-row {\n  font-size: 0.875rem;\n  border-bottom: 1px solid #f1f5f9;\n  transition: background-color 0.15s ease;\n}\n\n.fase-monitor__spare-row:hover {\n  background: #f8fafc;\n}\n\n.fase-monitor__spare-location {\n  padding: 0.875rem 1rem 0.35rem;\n  font-size: 0.8125rem;\n  font-weight: 700;\n  color: #475569;\n}\n\n.fase-monitor__spare-box {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  min-width: 0;\n}\n\n.fase-monitor__spare-sync {\n  color: #334155;\n}\n\n.fase-monitor__spare-head > :last-child,\n.fase-monitor__spare-seen {\n  text-align: right;\n}\n\n.fase-monitor__spare-seen {\n  color: #64748b;\n  font-size: 0.8125rem;\n}\n\n.fase-monitor--auth {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.fase-monitor__auth-overlay {\n  width: 100%;\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1.5rem;\n  box-sizing: border-box;\n}\n\n.fase-monitor__auth-card {\n  width: 100%;\n  max-width: 380px;\n  background: #ffffff;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  box-shadow: 0 4px 16px rgba(15, 23, 42, 0.08);\n  padding: 2rem 2rem 2.25rem;\n  box-sizing: border-box;\n}\n\n.fase-monitor__auth-logo-wrapper {\n  display: flex;\n  justify-content: center;\n  margin-bottom: 1.25rem;\n}\n\n.fase-monitor__auth-logo {\n  height: 38px;\n  width: auto;\n  object-fit: contain;\n}\n\n.fase-monitor__auth-title {\n  margin: 0 0 0.375rem;\n  font-size: 1.25rem;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  color: #0f172a;\n  text-align: center;\n}\n\n.fase-monitor__auth-subtitle {\n  margin: 0 0 1.75rem;\n  font-size: 0.875rem;\n  color: #64748b;\n  text-align: center;\n}\n\n.fase-monitor__auth-form {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.fase-monitor__auth-field {\n  display: flex;\n  flex-direction: column;\n  gap: 0.375rem;\n}\n\n.fase-monitor__auth-label {\n  font-size: 0.8125rem;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  color: #334155;\n}\n\n.fase-monitor__auth-input {\n  width: 100%;\n  padding: 0.5rem 0.75rem;\n  font-size: 0.9375rem;\n  border: 1px solid #cbd5e1;\n  border-radius: 8px;\n  color: #0f172a;\n  background: #ffffff;\n  box-sizing: border-box;\n  transition:\n    border-color 0.15s ease,\n    box-shadow 0.15s ease;\n}\n\n.fase-monitor__auth-input:focus {\n  outline: none;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15);\n}\n\n.fase-monitor__auth-input:disabled {\n  background: #f8fafc;\n  color: #94a3b8;\n}\n\n.fase-monitor__auth-error {\n  margin: 0;\n  padding: 0.625rem 0.75rem;\n  font-size: 0.875rem;\n  color: #dc2626;\n  background: #fef2f2;\n  border: 1px solid #fecaca;\n  border-radius: 8px;\n}\n\n.fase-monitor__auth-submit {\n  margin-top: 0.5rem;\n  padding: 0.625rem 1rem;\n  font-size: 0.9375rem;\n  font-weight: 600;\n  color: #ffffff;\n  background: #ff5300;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: background-color 0.15s ease;\n}\n\n.fase-monitor__auth-submit:hover:not(:disabled) {\n  background: #e04a00;\n}\n\n.fase-monitor__auth-submit:disabled {\n  background: #ffb899;\n  cursor: not-allowed;\n}\n\n@media (min-width: 720px) {\n  .fase-monitor__aircraft-row {\n    grid-template-columns: 130px minmax(0, 1fr);\n  }\n\n  .fase-monitor__aircraft-details {\n    grid-template-columns: minmax(0, 1fr) minmax(220px, 260px);\n  }\n}\n\n@media (max-width: 719px) {\n  .fase-monitor__aircraft-details {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
